/**
 * #694: the recurring memory-evaluation trend's client — kept as its own module the same way #690's
 * `memory-graph-api.ts` is, so Operations → Memory can grow this reading without touching the large `@/api`.
 *
 * A refused or broken read is raised rather than returned, for the same reason `memory-graph-api.ts` raises
 * one: a 401 or a 5xx answers a body shaped like `{ statusCode, message }`, and handing that to the trend as
 * though it were history would draw an empty chart that looks like "no evaluations have run yet". An operator
 * watching for degradation has to be able to tell those two apart.
 */
import type { MemoryEvalRunSummary } from '@zerohuman/shared'

export const memoryEvalApi = {
    /** #694 AC4: the enterprise's evaluation runs, oldest first. */
    runs: async (): Promise<MemoryEvalRunSummary[]> => {
        const response = await fetch('/v1/memory/evaluations', { credentials: 'include' })
        if (!response.ok) {
            throw new Error(`memory_eval_request_failed:${response.status}`)
        }
        return (await response.json()) as MemoryEvalRunSummary[]
    },
}
